import React from "react";
import { UrlButtonProps } from "../../types";
import { isTabActive } from "../../utils";

export const UrlButton = (props: UrlButtonProps) => {
  const { icon, text, url, classNames, isSubmenu } = props;
  const classes = classNames || [];
  const path = document.location.pathname;
  
  if (!isSubmenu ? isTabActive(url) : url === path) classes.push("active");
  
  return (
    <div className={["btn", ...classes].join(" ")}>
      <a href={url}>
        {icon}
        <p>{text}</p>
      </a>
    </div>
  );
};